module.exports = __webpack_public_path__ + "img/HQ-DNC-V1-T.e9075697.jpg";